import { useNavigate } from "react-router-dom";
import ProductHeroSection from "../components/Common/ProductHeroSection";
import WhyItMatters from "../components/Aida/WhyItMatters";
import ThirdSection from "../components/Aida/ThirdSection";
import HowItWorks from "../components/Aida/HowItWorkSection";
import KeyFeatures from "../components/Aida/KeyFeaturesSection";
import LandingHero from "../components/Common/LandingHero";
import data from "../content.json";
const Aida = () => {
  const navigate = useNavigate();

  const handleScheduleDemo = () => {
    navigate("/get-in-touch?purpose=Product Demo");
  };

  const heroButtons = [
    {
      label: "Book a Demo",
      className: "btn-secondary",
      onClick: handleScheduleDemo,
    },
    {
      label: "Contact Us",
      className: "btn-outline",
      onClick: () => {
        navigate("/get-in-touch");
      },
    },
  ];

  return (
    <>
      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.aida.hero} />
      </div>
      <div>
        {/* <ProductHeroSection
          backgroundImage="/assets/aida/hero-bg.svg"
          contentImage="/assets/aida/hero.svg"
          title="Turning Unreadable Data into Actionable Insights"
          description="Today’s organizations deal with vast amounts of data generated from multiple sources and in countless formats. Lot of this data is not correctly utilized as this is not in a machine-readable format."
          imagePosition="right"
          buttons={heroButtons}
        /> */}
        {/* <div className="h-16 md:h-20 lg:h-24 bg-white"></div> */}

        <WhyItMatters />
        <ThirdSection />
        <KeyFeatures />
        <HowItWorks />

        <div className="h-16 md:h-20 lg:h-24 bg-white"></div>
      </div>
    </>
  );
};

export default Aida;
